import { __rest } from "tslib";
import omit from 'rc-util/lib/omit';
import * as React from 'react';
import warning from '../_util/warning';
import Base from './Base';
const Text = (_a, ref) => {
    var { ellipsis } = _a, restProps = __rest(_a, ["ellipsis"]);
    const mergedEllipsis = React.useMemo(() => {
        if (ellipsis && typeof ellipsis === 'object') {
            return omit(ellipsis, ['expandable', 'rows']);
        }
        return ellipsis;
    }, [ellipsis]);
    warning(typeof ellipsis !== 'object' ||
        !ellipsis ||
        (!('expandable' in ellipsis) && !('rows' in ellipsis)), 'Typography.Text', '`ellipsis` do not support `expandable` or `rows` props.');
    return React.createElement(Base, Object.assign({ ref: ref }, restProps, { ellipsis: mergedEllipsis, component: "span" }));
};
export default React.forwardRef(Text);
